import { render } from "./RecipePageRework.vue?vue&type=template&id=32bb476d&scoped=true"
import script from "./RecipePageRework.vue?vue&type=script&lang=js"
export * from "./RecipePageRework.vue?vue&type=script&lang=js"

import "./RecipePageRework.vue?vue&type=style&index=0&id=32bb476d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bb476d"]])

export default __exports__